/**
 * SplineScene — обёртка вокруг @splinetool/react-spline (21st.dev «splite»).
 * Грузится лениво (отдельный чанк) — тяжёлый Spline runtime не попадает
 * в основной бандл лендинга и подгружается только при показе сцены.
 */
import { Suspense, lazy } from "react";

const Spline = lazy(() => import("@splinetool/react-spline"));

interface SplineSceneProps {
  /** URL опубликованной сцены: https://prod.spline.design/<id>/scene.splinecode */
  scene: string;
  className?: string;
  onLoad?: () => void;
}

export function SplineScene({ scene, className, onLoad }: SplineSceneProps) {
  return (
    <Suspense fallback={<SplineFallback />}>
      <Spline scene={scene} className={className} onLoad={onLoad} />
    </Suspense>
  );
}

function SplineFallback() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <span className="spline-loader" aria-hidden />
    </div>
  );
}
